const SPOTIFY_PLAYLIST_DEFAULT = "7dndAU8TbtLjVSkT6KVd1A";

/**
 * Progressive enhancement for the server-rendered error / not-found pages. The heading,
 * message, request id and home link are rendered server-side (Razor + resx) so the page
 * is fully usable without JavaScript. This element only lazy-loads the Spotify embed; it
 * never renders the page content (a Lit light-DOM render would clobber the
 * server-rendered children and blank the page when JS is disabled).
 */
export class HelpJonasErrorPage extends HTMLElement {
  connectedCallback(): void {
    const slot = this.querySelector<HTMLElement>("[data-spotify-slot]");
    if (!slot || slot.dataset.enhanced === "true") {
      return;
    }
    const playlist = slot.dataset.playlist || SPOTIFY_PLAYLIST_DEFAULT;
    const inject = (): void => this.injectSpotify(slot, playlist);
    if (typeof window.requestIdleCallback === "function") {
      window.requestIdleCallback(inject, { timeout: 2000 });
    } else {
      window.setTimeout(inject, 0);
    }
  }

  private injectSpotify(slot: HTMLElement, playlist: string): void {
    slot.dataset.enhanced = "true";
    const iframe = document.createElement("iframe");
    iframe.src = `https://open.spotify.com/embed/playlist/${encodeURIComponent(playlist)}`;
    iframe.width = "300";
    iframe.height = "380";
    iframe.loading = "lazy";
    iframe.title = "AFAS Help — Spotify";
    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute("allow", "encrypted-media");
    slot.appendChild(iframe);
  }
}

if (!customElements.get("help-jonas-error-page")) {
  customElements.define("help-jonas-error-page", HelpJonasErrorPage);
}
